import store from '@/store'
// 温度单位转换--带单位
export function temChangeUnit(num) {
  if (num && typeof num === 'string') { // 去除首位空格
    num = num.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
  }
  if ((num || num == 0) && num != '--') {
    if (typeof num === 'string')num = Number(num)
    var temType = store.state.temType || 'ssd'
    if (temType != 'ssd') { // 华氏度
      return Math.round(32 + 1.8 * num) + '℉'
    } else {
      return num + '℃'
    }
  } else {
    return '--'
  }
}
// 温度单位转换--不带单位
export function temChange(num) {
  if (num && typeof num === 'string') { // 去除首位空格
    num = num.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
  }

  if ((num || num == 0) && num != '--') {
    if (typeof num === 'string')num = Number(num)
    var temType = store.state.temType || 'ssd'
    if (temType != 'ssd') { // 华氏度
      return Math.round(32 + 1.8 * num)
    } else {
      return num
    }
  } else {
    return '--'
  }
}
// 将值转成摄氏度，因为提交到后台的数据必须为摄氏度
export function temHsdToSsd(num) {
  if (num && typeof num === 'string') { // 去除首位空格
    num = num.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
  }
  if ((num || num == 0) && num != '--') {
    if (typeof num === 'string')num = Number(num)
    var temType = store.state.temType || 'ssd'
    if (temType != 'ssd') { // 华氏度
      return Math.round((num - 32) / 1.8)
    } else {
      return num
    }
  } else {
    return '--'
  }
}
// 温度单位
export function temUnit() {
  var temType = store.state.temType || 'ssd'
  if (temType != 'ssd') { // 华氏度
    return '℉'
  } else {
    return '℃'
  }
}
